import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components'
import { withFormik } from 'formik';
import Yup from 'yup';
import isEmpty from 'lodash/isEmpty'
import Header from '../../components/Header/Header';
import Main from '../../components/Main/Main';
import Card from '../../components/Card/Card';
import Footer from '../../components/Footer/Footer';
import TextInput from "../../components/Form/TextInputUX";
import GoogleRecaptcha from "../../components/Form/GoogleRecaptcha";
import ButtonWrapper from "../../components/Form/ButtonWrapper";
import Button from "../../collections/Button/Button";
import FormikForm from "../../components/Form/FormikForm";
import {media} from "../../utilities/style-utilities";
import {withRouter} from "react-router-dom";
import Status from "../../components/Status/Status";
import {emy} from "../../utilities/utilities";
const queryString = require('query-string');

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 1rem;
  ${ media.desktop`
    flex-direction: column;
  `}
`;

const FlexRowItem = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  ${ media.desktop`
    flex: 1 1 auto;
  `}
`;

const buttonStyle = {
  width:'auto' ,
  padding:'.6rem 3rem;',
  fontSize: emy(15)
};

const sitekey = process.env.REACT_APP_GOOGLE_RECAPTCHA;

const RequestNewPasswordPage = (props) => {
    const {
        // values,
        // touched,
        errors,
        dirty,
        isSubmitting,
        // handleChange,
        // handleBlur,
        // handleSubmit,
        // handleReset,
        setFieldValue
      } = props;
    return (
        <Fragment>

            <Helmet>
                {/* props.appState.ui.terms.meta.title */}
                <title>{`Request new Password`}</title>
                <meta name="description" content={`props.appState.ui.newPasswordRequest.meta.description`} />
            </Helmet>

            <Header header={props.appState.ui.header} url={props.url}/>
            <Main site={props.appState.ui.site} >
                {/* props.appState.ui.terms.card.titleText */}
                <Card fontFamily={props.appState.ui.passwordReset.card.fontFamily} card={props.appState.ui.newPasswordRequest.card} >

                    <Status isVisible={props.appState.cardActivation.status.isVisible} message={props.appState.cardActivation.status.message} type={props.appState.cardActivation.status.type}/>

                    <FormikForm>
                        <FlexRow>
                            <FlexRowItem>
                                <TextInput
                                    name="email"
                                    type={props.appState.ui.newPasswordRequest.formValidation.email.inputType}
                                    label={props.appState.ui.newPasswordRequest.formValidation.email.label}
                                    placeholder={props.appState.ui.newPasswordRequest.formValidation.email.placeholder}
                                />
                                <TextInput
                                    name="confirmEmail"
                                    type={props.appState.ui.newPasswordRequest.formValidation.confirmEmail.inputType}
                                    label={props.appState.ui.newPasswordRequest.formValidation.confirmEmail.label}
                                    placeholder={props.appState.ui.newPasswordRequest.formValidation.confirmEmail.placeholder}
                                />
                                <GoogleRecaptcha sitekey={sitekey} size="normal" onChange={(response) => { setFieldValue("recaptcha", response); }}/>
                                <ButtonWrapper>
                                    <Button style={buttonStyle}
                                            color={props.appState.ui.newPasswordRequest.buttons.submit.textColor}
                                            background={props.appState.ui.newPasswordRequest.buttons.submit.backgroundColor}
                                            border={props.appState.ui.newPasswordRequest.buttons.submit.borderColor}
                                            type="submit"
                                            role="button"
                                            disabled={isSubmitting || !isEmpty(errors) || !dirty}>
                                        {props.appState.ui.newPasswordRequest.buttons.submit.text}
                                    </Button>
                                </ButtonWrapper>
                            </FlexRowItem>

                        </FlexRow>
                    </FormikForm>

                </Card>
            </Main>
            <Footer footer={props.appState.ui.footer} url={props.url} clientTerms={props.appState.ui.clientTerms} />

        </Fragment>
    );

};

const EnhancedForm = withFormik({
    mapPropsToValues: (props) => ({
        email:'',
        confirmEmail:'',
        recaptcha: ''

    }),
    validationSchema: (props) => { return Yup.object().shape({
        email: Yup.string()
            .email(props.appState.ui.newPasswordRequest.formValidation.email.regexMessage)
            .max(50, "This field has a maximum allowed character limit of 50.")
            .required(props.appState.ui.newPasswordRequest.formValidation.email.requiredMessage),
        confirmEmail: Yup.string()
            .oneOf([Yup.ref('email'), null], props.appState.ui.newPasswordRequest.formValidation.confirmEmail.invalid)
            .email(props.appState.ui.newPasswordRequest.formValidation.email.regexMessage)
            .required(props.appState.ui.newPasswordRequest.formValidation.confirmEmail.requiredMessage),
        recaptcha: Yup.string()
            .required()
    })},
    handleSubmit: (values, { props, setSubmitting }) => {
        setSubmitting(true);
        props.api.requestNewPassword(values.confirmEmail)
            .then(response => {
                if(response !== null){
                    props.history.push('/success',
                        {
                            title: "Check your inbox",
                            description:"<p>You will receive a confirmation email to reset your password<p>",
                        }
                    );
                }else{
                    props.handleStatusMessage(true, 'The application encountered an error processing your request. Please try again, we are sorry for the inconvenience.', `error`);
                    setSubmitting(false);
                }
            })
            .catch(error => {
                let message = 'The application encountered an error processing your request. Please try again, we are sorry for the inconvenience.'
                if(error.response){
                    switch(parseInt(error.response.status)){
                        case 400:
                            message = 'The application encountered an error processing your request. Please register a new account via the app. Sorry for any inconvenience caused.';
                            break;
                        default:
                            message = 'The application encountered an error processing your request. Please try again, we are sorry for the inconvenience.'
                    }
                }

                props.handleStatusMessage(true, message , `error`);
                setSubmitting(false);
            });
    }
})(RequestNewPasswordPage);


export default  withRouter(EnhancedForm);
//
// export default RequestNewPasswordPage;


// WEBPACK FOOTER //
// ./src/containers/RequestNewPasswordPage/RequestNewPasswordPage.js